import { Checkbox } from "@/components/ui/checkbox";
import { useI18n } from "@/context/I18nContext";

export const PAY_LABELS = { cb: "CB", cheque: "Chèque", virement: "Virement", financement: "Financement" };

export const PayMethods = ({ label, methods, value, onChange, testid }) => {
  const { t } = useI18n();
  return (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={testid}>
    <span className="text-muted-foreground">{label}</span>
    {methods.map((m) => (
      <label key={m} className="flex items-center gap-1 cursor-pointer">
        <Checkbox checked={value.includes(m)} data-testid={`${testid}-${m}`}
          onCheckedChange={(v) => onChange(v ? [...value, m] : value.filter((x) => x !== m))} />
        {t(PAY_LABELS[m])}
      </label>
    ))}
  </div>
  );
};
